import { render, staticRenderFns } from "./CategoryEditor.vue?vue&type=template&id=1f5c0950&scoped=true"
import script from "./CategoryEditor.vue?vue&type=script&lang=js"
export * from "./CategoryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5c0950",
  null
  
)

export default component.exports